<template>
  <div ref="container" class="map-container">
    <svg ref="map" :width="width" :height="height">
      <defs>
        <pattern
          id="bg-striped"
          x="0"
          y="0"
          width="100"
          height="100"
          patternUnits="userSpaceOnUse"
        >
          <rect fill="#F3F4F6" width="100" height="100" />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="46.97"
            y1="-53.03"
            x2="153.03"
            y2="53.03"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="43.84"
            y1="-49.91"
            x2="149.91"
            y2="56.16"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="40.72"
            y1="-46.78"
            x2="146.78"
            y2="59.28"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="37.59"
            y1="-43.66"
            x2="143.66"
            y2="62.41"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="34.47"
            y1="-40.53"
            x2="140.53"
            y2="65.53"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="31.34"
            y1="-37.41"
            x2="137.41"
            y2="68.66"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="28.22"
            y1="-34.28"
            x2="134.28"
            y2="71.78"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="25.09"
            y1="-31.16"
            x2="131.16"
            y2="74.91"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="21.97"
            y1="-28.03"
            x2="128.03"
            y2="78.03"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="18.84"
            y1="-24.91"
            x2="124.91"
            y2="81.16"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="15.72"
            y1="-21.78"
            x2="121.78"
            y2="84.28"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="12.59"
            y1="-18.66"
            x2="118.66"
            y2="87.41"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="9.47"
            y1="-15.53"
            x2="115.53"
            y2="90.53"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="6.34"
            y1="-12.41"
            x2="112.41"
            y2="93.66"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="3.22"
            y1="-9.28"
            x2="109.28"
            y2="96.78"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="0.09"
            y1="-6.16"
            x2="106.16"
            y2="99.91"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-3.03"
            y1="-3.03"
            x2="103.03"
            y2="103.03"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-6.16"
            y1="0.09"
            x2="99.91"
            y2="106.16"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-9.28"
            y1="3.22"
            x2="96.78"
            y2="109.28"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-12.41"
            y1="6.34"
            x2="93.66"
            y2="112.41"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-15.53"
            y1="9.47"
            x2="90.53"
            y2="115.53"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-18.66"
            y1="12.59"
            x2="87.41"
            y2="118.66"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-21.78"
            y1="15.72"
            x2="84.28"
            y2="121.78"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-24.91"
            y1="18.84"
            x2="81.16"
            y2="124.91"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-28.03"
            y1="21.97"
            x2="78.03"
            y2="128.03"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-31.16"
            y1="25.09"
            x2="74.91"
            y2="131.16"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-34.28"
            y1="28.22"
            x2="71.78"
            y2="134.28"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-37.41"
            y1="31.34"
            x2="68.66"
            y2="137.41"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-40.53"
            y1="34.47"
            x2="65.53"
            y2="140.53"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-43.66"
            y1="37.59"
            x2="62.41"
            y2="143.66"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-46.78"
            y1="40.72"
            x2="59.28"
            y2="146.78"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-49.91"
            y1="43.84"
            x2="56.16"
            y2="149.91"
          />
          <line
            style="stroke:#e5e7eb;stroke-miterlimit:10;stroke-width:1.5px;"
            x1="-53.03"
            y1="46.97"
            x2="53.03"
            y2="153.03"
          />
        </pattern>
      </defs>
    </svg>
  </div>
</template>

<script>
import * as d3 from "d3";
import * as topojson from "topojson-client";

// import countriesGeo from "@/assets/data/countries-110m";
// import countriesGeo from "@/assets/data/countries-popcouncil";
import countriesGeo from "@/assets/data/national_boundaries";
// only when using the countries-110m.json
// import codes from "@/assets/data/country-codes";

export default {
  name: "WorldMap",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    range: {
      type: Array,
      default: null,
    },
    iso: {
      type: String,
      default: "",
    },
    colors: {
      type: [Object, Function],
      default: () => ({ min: "#DBEAFE", max: "#1E3A8A" }),
    },
    highlightColor: {
      type: String,
      default: "black",
    },
    noDataColor: {
      type: String,
      default: "#f3f4f6",
    },
    strokeColor: {
      type: String,
      default: "#ffffff",
    },
    isoId: {
      type: String,
      default: "id",
    },
    duration: {
      type: Number,
      default: 500,
    },
    // will be NOT shown in the map
    removeFeatures: {
      type: Array,
      default: () => ["010"], // Antartica, Fiji
    },
    // will be ignored for calculating bounds of the map (but could be shown)
    removeFeaturesForBounds: {
      type: Array,
      // default: () => ["010", "242", "840"], // Antartica, Fiji, USA (for hawaii)
      default: () => [
        "FJI",
        "USA",
        "TON",
        "WSM",
        "ASM",
        // "NZL",
        "NIU",
        "KIR",
        "PYF",
        "ZAF", // it has a tiny island south
      ], // Fiji, USA (for hawaii), Tonda, West Samoa, American Samoa, NZ for the small islands
    },
    projection: {
      type: String,
      default: "geoNaturalEarth1",
    },
    adjustSize: {
      type: Boolean,
      default: false,
    },
    accessor: {
      type: Function,
      default: (d) => d.properties.ISO_A3, // use d.id for countries-110m.json
    },
    // wether to calculate the boundaries of the map considering only the countries with data
    fitBoundsToData: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: [Number, String],
      default: null,
    },
    scale: {
      type: Number,
      default: 1,
    },
    maxZoom: {
      type: Number,
      default: 16,
    },
    useBgPattern: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      width: 1000,
      height: 300,
      tooltip: {
        show: false,
        name: "",
        value: 0,
      },
      firstPaint: false,
    };
  },
  computed: {
    max() {
      return d3.max(Object.values(this.data), (d) => d.value);
    },
    colorScale() {
      if (typeof this.colors === "function") {
        return this.colors;
      }
      const interpolator = d3.interpolateRgb(this.colors.min, this.colors.max);
      const scale = d3.scaleLinear().domain([0, this.max]);
      return d3
        .scaleSequential((d) => interpolator(scale(d)))
        .unknown(this.noDataColor);
    },
    featureCollection() {
      const featureCollection = topojson.feature(
        countriesGeo,
        countriesGeo.objects.countries
      );

      const filterCountries = (e) =>
        !this.removeFeatures.includes(this.accessor(e));

      return {
        ...featureCollection,
        features: featureCollection.features.filter(filterCountries),
      };
    },
    keepCountries() {
      return Object.keys(this.data);
    },
    scaleFactor() {
      // if (this.fitBoundsToData && this.keepCountries.length) return 0.95;
      // return 1;
      return 0.95;
    },
    // ALL COUNTRIES
    featureCollectionBounds() {
      // calculate the bounds of the map
      let filterCountriesForBounds;

      // consider all countries except those we want to explicitly remove
      filterCountriesForBounds = (e) =>
        !this.removeFeaturesForBounds.includes(this.accessor(e));

      return {
        ...this.featureCollection,
        features: this.featureCollection.features.filter(
          filterCountriesForBounds
        ),
      };
    },
    // ONLY COUNTRIES WITH DATA
    featureCollectionBoundsFit() {
      // calculate the bounds of the map
      let filterCountriesForBounds;
      // consider only countries with data
      // we only do this if we have data! otherwise it will throw an error
      if (this.fitBoundsToData && this.keepCountries.length) {
        filterCountriesForBounds = (e) =>
          this.keepCountries.includes(this.accessor(e)) &&
          !this.removeFeaturesForBounds.includes(this.accessor(e));
      } else {
        // consider all countries except those we want to explicitly remove
        filterCountriesForBounds = (e) =>
          !this.removeFeaturesForBounds.includes(this.accessor(e));
      }

      return {
        ...this.featureCollection,
        features: this.featureCollection.features.filter(
          filterCountriesForBounds
        ),
      };
    },
  },
  watch: {
    data() {
      if (this.fitBoundsToData && !this.firstPaint) {
        this.draw();
        this.firstPaint = true;
        this.zoomToFitBounds();
      } else {
        // do this to recenter the map and fit to bounds... maybe we don't need it.
        if (this.fitBoundsToData) this.zoomToFitBounds();
        this.updateColors();
      }
    },
    fitBoundsToData() {
      this.zoomToFitBounds();
      // this.draw();
    },
    selected() {
      this.highlight();
    },
    scale(newVal, oldVal) {
      const currentTransform = d3.zoomTransform(this.svg.node());
      if (newVal > oldVal) {
        this.zoomToScale(parseInt(currentTransform.k) * 2);
      } else {
        this.zoomToScale(parseInt(currentTransform.k) / 2);
      }
    },
  },
  mounted() {
    this.setSize();
    this.createMap();
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.resize();
      });
      this.resizeObserver.observe(this.$refs.container);
    } else {
      // for IE
      window.addEventListener("resize", this.resize);
    }
  },
  beforeDestroy() {
    if (window.ResizeObserver) {
      this.resizeObserver.unobserve(this.$refs.container);
    } else {
      // for IE
      window.removeEventListener("resize", this.resize);
    }
  },
  methods: {
    draw() {
      this.zoom = d3
        .zoom()
        .scaleExtent([1, this.maxZoom])
        .on("zoom", this.zoomed);

      const projection = d3["geoNaturalEarth1"]()
        .scale(1)
        .translate([0, 0]);

      this.path = d3.geoPath().projection(projection);

      const b = this.path.bounds(this.featureCollectionBounds);

      if (!this.adjustSize) {
        // DO NOT DO THIS if you want to be limited by the height/width of the container
        // DO THIS only if you want the WIDTH of the container to determine the final size of the map
        //calculate aspect ratio
        const aspectRatio = (b[1][0] - b[0][0]) / (b[1][1] - b[0][1]);
        //set height based on aspect ratio
        this.height = this.width / aspectRatio;
        // END of the scary "DO NOT DO THIS"
      }

      // set the viewBox
      this.svg = d3
        .select(this.$refs.map)
        .attr("viewBox", `0 0 ${this.width} ${this.height}`);

      // some math to calculate the scale in function of the bounds and the width/height
      const s =
        this.scaleFactor /
        Math.max(
          (b[1][0] - b[0][0]) / this.width,
          (b[1][1] - b[0][1]) / this.height
        );
      // more math for centering the map...
      const t = [
        (this.width - s * (b[1][0] + b[0][0])) / 2,
        (this.height - s * (b[1][1] + b[0][1])) / 2,
      ];

      // and finally scale and translate the projection
      projection.scale(s).translate(t);
      // region borders
      this.regions = this.mapContainer
        .selectAll("path")
        .data(this.featureCollection.features)
        .join("path");

      this.regions
        .attr("stroke", this.strokeColor)
        .attr("stroke-width", 1)
        .attr("class", "region")
        .attr("id", (d) => `region-${this.accessor(d)}`)
        .attr("d", this.path);

      // emit events on hover
      this.regions
        .on("mouseover", (event, mapData) => {
          let data = this.data[this.accessor(mapData)];
          if (!data) data = {};

          data.id = this.accessor(mapData);

          this.$emit("hover", { event, data });
        })
        .on("mouseout", () => {
          this.$emit("hover", null);
        })
        .on("click", (event, data) => {
          this.$emit("click", { event, iso: this.accessor(data) });
        });

      this.updateColors();

      this.svg.call(this.zoom).on("wheel.zoom", null);

      if (this.fitBoundsToData) {
        this.zoomToFitBounds();
      }
    },
    zoomed(event) {
      const { transform } = event;
      this.$emit("zoom", transform);
      this.mapContainer.attr("transform", transform);
      this.regions.attr("stroke-width", 1 / transform.k);
    },
    zoomToFitBounds(/*event, d*/) {
      const [[x0, y0], [x1, y1]] = this.path.bounds(
        this.featureCollectionBoundsFit
      );
      // event.stopPropagation();

      this.svg
        .transition()
        .duration(750)
        .call(
          this.zoom.transform,
          d3.zoomIdentity
            .translate(this.width / 2, this.height / 2)
            .scale(
              Math.min(
                8,
                this.scaleFactor /
                  Math.max((x1 - x0) / this.width, (y1 - y0) / this.height)
              )
            )
            .translate(-(x0 + x1) / 2, -(y0 + y1) / 2)
          // d3.pointer(event, svg.node())
        );
    },
    zoomToScale(scale) {
      if (scale <= 1) {
        this.svg
          .transition()
          .duration(750)
          .call(this.zoom.transform, d3.zoomIdentity);
      } else {
        this.svg
          .transition()
          .duration(750)
          .call(this.zoom.scaleTo, scale);
      }
    },
    setSize() {
      const container = this.$refs.container;
      if (container) {
        this.width = container.clientWidth;
        this.height = container.clientHeight;
      }
    },
    resize() {
      const currentWidth = this.width;
      const currentHeight = this.height;
      this.setSize();
      if (currentWidth !== this.width || currentHeight !== this.height) {
        this.updateMap();
      }
    },
    updateMap() {
      // reset the transform and the stroke width of the regions
      this.mapContainer.attr("transform", "translate(0) scale(1)");

      this.draw();
    },
    updateColors() {
      this.regions
        .transition()
        .duration(this.duration)
        .attr("fill", this.getColor)
        .attr("stroke", this.getStrokeColor);
    },
    createMap() {
      this.mapContainer = d3.select(this.$refs.map).append("g");
      this.draw();
      // if (this.fitBoundsToData) this.zoomToFitBounds();
    },
    highlight() {
      // console.log(this.selected);
      if (this.selected === null)
        this.regions.attr("stroke", this.getStrokeColor).lower();
      this.mapContainer
        .select(`#region-${this.selected}`)
        .attr("stroke", this.highlightColor)
        .raise();
    },
    getColor(d) {
      if (!this.data[this.accessor(d)])
        return this.useBgPattern ? "url(#bg-striped)" : this.noDataColor;
      return this.colorScale(this.data[this.accessor(d)].value);
    },
    getStrokeColor(d) {
      // MALDIVES is too small to be seen, we paint the stroke
      if (["MDV", "TON"].includes(this.accessor(d))) {
        return this.getColor(d);
      }
      return this.strokeColor;
    },
  },
};
</script>
